import React, { Fragment, useState, useEffect } from "react";
import _ from "lodash";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Grid } from "@material-ui/core";
import { withStyles, makeStyles, createStyles } from "@material-ui/core/styles";
import { setOverviewTab, getInGameItemSalesByPmid } from "actions";
import * as C from "components";
import * as H from "helper";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      backgroundColor: "#fafafa",
    },
  })
);

const InGameItemByPmid = ({
  setOverviewTab,
  getInGameItemSalesByPmid,
  game,
  loading,
}) => {
  const classes = useStyles();

  useEffect(() => {
    setOverviewTab("pmid");
    const game = window.location.pathname.split("/");
    getInGameItemSalesByPmid(game[2]);
  }, [window.location.pathname]);

  // useEffect(() => {
  //   setOverviewTab("pmid");
  //   const game = window.location.pathname.split("/");
  //   getInGameItemSalesByPmid(game[2]);
  // }, [game]);

  return (
    <Fragment>
      <Grid container spacing={3}>
        <Grid item sm={12} lg={6}>
          <C.Top10AmountByPmid
            title="TOP20 PMID別FIAT課金取引額"
            source="ingame-fiat"
            loading={loading}
          />
        </Grid>
        <Grid item sm={12} lg={6}>
          <C.Top10TxCountByPmid
            title="TOP20 PMID別FIAT課金取引件数"
            source="ingame-fiat"
            loading={loading}
          />
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid item sm={12} lg={6}>
          <C.Top10AmountByPmid
            title="TOP20 PMID別DEP課金取引額"
            source="ingame-dep"
            loading={loading}
          />
        </Grid>
        <Grid item sm={12} lg={6}>
          <C.Top10TxCountByPmid
            title="TOP20 PMID別DEP課金取引件数"
            source="ingame-dep"
            loading={loading}
          />
        </Grid>
      </Grid>
    </Fragment>
  );
};

InGameItemByPmid.propTypes = {
  classes: PropTypes.object,
};

const mapStateToProps = (state) => ({
  dateRange: state.page.dateRange,
  dateLoaded: state.data.dataLoaded,
  loading: state.inGameItemSales.loading,
});

const mapDispatchToProps = (dispatch) => ({
  setOverviewTab: (param) => dispatch(setOverviewTab(param)),
  getInGameItemSalesByPmid: (param) =>
    dispatch(getInGameItemSalesByPmid(param)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(null, { withTheme: true })(InGameItemByPmid));
